import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import facebook from "../assets/images/facebook.webp";
import telegram from "../assets/images/telegram.webp";
import age18 from "../assets/images/age18.webp";
import logo from "../assets/images/logo.png";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { Button, Modal } from "react-bootstrap";
import WinnerSlider from "../components/WinnerSlider";

const FooterSection = () => {
  const downloadPopup = useContextSelector(AuthContext, (ctx) => ctx.downloadPopup);
  const downloadPopupToggle = useContextSelector(AuthContext, (ctx) => ctx.downloadPopupToggle);
  const { t } = useTranslation();
  const [showImg, setShowImg] = useState(true);
  const navigate = useNavigate();
  return (
    <>
      <div class="winner-board">
        <div class="game-title">
          <div class="title-content">
            <div class="title-text">
              <img class="title-icon" />
              <span class="title-name">সর্বশেষ বিজয়ী</span>
            </div>
          </div>
        </div>
        <WinnerSlider />
      </div>
      <div className="home-footer-wrap">
        <div className="home-footer-content">
          <div class="home-footer-container">
            <div class="footer-vendor">
              <div class="vendor-icon-wrap ">
                <div class="vendor-icon-list">
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//JL-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//SPB-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//PG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//JDB-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//FC-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//BNG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//PP-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//MG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//NS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//BT-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//SG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//SS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//YB-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//PS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//AMG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//FS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//WD-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//GM-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//5G-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//BOM-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//KA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//BGA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//L22-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//VA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//HS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//JK-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//759-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//NG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//AMBS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//MAS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//MAHA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//AE-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//YL-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//FTG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//EZG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//MA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//EP-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//RLX-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//MNP-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//TPG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//AUX-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//PAS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//OCT-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//GPI-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//RT-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//CG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//NE-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//BTG-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//NLC-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//YGD-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//OBS-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//BSP-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//FP-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//PT-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//EGT-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//EG4-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//SEX-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//EZ-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//VIA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//WJ-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//AIL-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//SA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//U9W-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//LUC-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//BTI-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//FB-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//UG2-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//PIN-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//POLY-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//SV3-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//RCB-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//OBSB-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//SB-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//TF-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//IA-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//KP-COLOR.png"
                    alt=""
                  />
                  <img
                    class="vendor-icon"
                    src="https://images.6492394993.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR//TCG_SEA-COLOR.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal
        show={downloadPopup}
        onHide={downloadPopupToggle}
        className="download-bar-model-shell"
        centered
      >
       
        <Modal.Body>
          <div class="bar-model-contents">
            <div class="bar-model-closes" onClick={downloadPopupToggle}>
              <svg class="am-icon am-icon-btn-close_b4e2c925 am-icon-md">
                <use xlinkHref="#btn-close_b4e2c925"></use>
              </svg>
            </div>
            <div class="download-box">
              <div class="appdown-list">
                <div class="list-right">
                  <a
                    class="item-link"
                    rel="nofollow me noopener noreferrer"
                    href="https://images.6492394993.com/wsd-images-prod/bet15bdtf6/merchant_resource/android/NBAJEE_20250528165132.apk"
                    target="_self"
                  >
                    <div class="app-info">
                      <svg class="am-icon am-icon-icon-android am-icon-md nav-icon">
                        <use xlinkHref="#icon-android"></use>
                      </svg>
                      <h5>অ্যান্ড্রয়েড অ্যাপ</h5>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default FooterSection;
